<!-- 新增固定资产弹窗组件 (可以保存为单独的 AssetFormModal.vue) -->
<template>
  <Modal v-model="visible" type="drawer-right" hasCloseIcon @close="onClose">
    <div slot="header" class="h-panel-bar">
      <span class="h-panel-title">固定资产信息</span>
    </div>
    <Form ref="form" v-width="800" mode="twocolumn" :labelWidth="150" :model="formData" :rules="validationRules">
      <FormItem label="资产类别:" prop="assetsTypeId">
        <Select v-model="formData.assetsTypeId" :datas="assetsType" keyName="id" titleName="categoryName"
                :filterable="true" :allow-create="true" placeholder="请输入或选择资产类别"></Select>
      </FormItem>
      <FormItem label="资产编码:" prop="assetsCode">
        <input type="text" v-model="formData.assetsCode">
      </FormItem>
      <FormItem label="资产名称:" prop="assetsName">
        <input type="text" v-model="formData.assetsName">
      </FormItem>

      <FormItem label="部门:" prop="deptId">
        <Select v-model="formData.deptId" :datas="dept" keyName="id" titleName="name"
                :filterable="true" :allow-create="true" placeholder="请输入或选择部门名称"></Select>
      </FormItem>
      <FormItem label="开始折旧日期:" prop="checkDate">
        <DatePicker type="month" v-model="formData.checkDate" :disabled="editInput"/>
      </FormItem>
<!--      <FormItem label="上次折旧日期:" prop="entryDate">-->
<!--        <DatePicker type="month" v-model="formData.entryDate" :disabled="true" />-->
<!--      </FormItem>-->
      <FormItem label="录入时间:" prop="luruDate" >
        <DatePicker type="date" v-model="formData.luruDate"  />
      </FormItem>
      <FormItem label="单位:" prop="specification">
        <Select v-model="formData.specification" :datas="unit" keyName="id" titleName="name"
                :filterable="true" :allow-create="true" placeholder="请输入或选择单位"></Select>
      </FormItem>
      <FormItem label="备注:" prop="remark">
        <input type="text" v-model="formData.remark">
      </FormItem>

      <FormItem label="资产费用科目:" prop="debitSubject">
        <Select v-model="formData.debitSubject" :datas="voucherSelect" keyName="id" titleName="subjectFullName"
                :filterable="true" :allow-create="true" placeholder="请输入或选择资产费用科目"></Select>
      </FormItem>
      <FormItem label="累计折旧科目:" prop="creditSubject">
        <Select v-model="formData.creditSubject" :datas="voucherSelect" keyName="id" titleName="subjectFullName"
                :filterable="true" :allow-create="true" placeholder="请输入或选择累计折旧科目"></Select>
      </FormItem>
      <FormItem label="资产单价:" prop="price">
        <NumberInput v-model.number="formData.price" :precision="2" :min="0" :disabled="editInput"></NumberInput>
      </FormItem>
      <FormItem label="资产数量:" prop="number">
        <NumberInput v-model.number="formData.number" :min="1" :useOperate="true" :useInt="true" :disabled="editInput"></NumberInput>
      </FormItem>
      <FormItem label="资产原值:" prop="originalValue">
        <NumberInput v-model.number="formData.originalValue" :precision="2" :min="0" :disabled="true"></NumberInput>
      </FormItem>

      <FormItem label="折旧总月:" prop="expectUseMonth">
        <NumberInput v-model.number="formData.expectUseMonth" :min="0" :useOperate="true" :useInt="true" :disabled="editInput"></NumberInput>
      </FormItem>
      <FormItem label="已折月数:" prop="useMonth">
        <NumberInput v-model.number="formData.useMonth" :min="0" :max="formData.expectUseMonth" :useOperate="true" :useInt="true" :disabled="editInput"></NumberInput>
      </FormItem>
      <FormItem label="月折旧额:" prop="currentMonthDepreciation">
        <NumberInput v-model="formData.currentMonthDepreciation" :precision="2" :min="0" :disabled="true"></NumberInput>
      </FormItem>
    </Form>
    <div class="text-center">
      <Button color="green" @click="submit" :loading="loading">{{formData.id?'更新':'保存'}}</Button>
      <Button @click="visible = false">取消</Button>
    </div>
  </Modal>
</template>


<script>
import moment from "moment/moment";

const emptyForm = {
  "assetsCode": "",
  "assetsName": "",
  "specification": "",
  "assetsTypeId": null,
  "deptId": null,
  "entryDate": "",
  "checkDate": "",
  "debitSubject": null,
  "creditSubject": null,
  "originalValue": 0,
  "expectUseMonth": 0,
  "useMonth": 0,
  "remainingUseMonth": 0,
  "currentMonthDepreciation": 0,
  "totalDepreciation": 0,
  "remark": "",
  "price": 0,
  "number": 1,
  "disposalDate": "",
  "disposal": "",
  "disposalNumber": 1,
  "luruDate": moment().format('YYYY-MM-DD')
};

export default {
  name: 'AssetFormModal',
  props: {
    value: Boolean, // 控制弹窗显示隐藏
    assetData: Object // 编辑时传入的数据
  },
  data() {
    return {
      visible: this.value,
      formData: Object.assign({}, emptyForm),
      assetsType: [],      // 资产类别数据
      voucherSelect: [],   // 凭证选择数据
      dept: [],            // 部门数据
      unit: [
        { id: '台', name: '台' },
        { id: '张', name: '张' },
        { id: '套', name: '套' },
        { id: '个', name: '个' },
        { id: '组', name: '组' },
        { id: '件', name: '件' },
        { id: '辆', name: '辆' },
        { id: '把', name: '把' }
      ],
      validationRules: {
        required: ["assetsCode", "assetsName", "assetsTypeId", "deptId", "checkDate","luruDate", "debitSubject", "creditSubject",
          "expectUseMonth","price","number"
        ]
      },
      loading: false,
      editInput: false,
      deptId: null  // 部门类别ID
    };
  },
  watch: {
    value(val) {
      this.visible = val;
      if (val && this.assetData) {
        this.formData = Object.assign({}, this.assetData);
        this.editInput = !!this.assetData.entryDate;
      } else if (val) {
        this.formData = Object.assign({}, emptyForm);
        this.editInput = false;
        // 加载所需数据
        this.loadData();
        // 生成资产编码
        this.generateNextAssetsCode().then(code => {
          this.formData.assetsCode = code;
        });
      }
    },
    visible(val) {
      this.$emit('input', val);
      if (!val) {
        this.$emit('close');
      }
    },
    // 监听 资产原值 属性的变化
    'formData.originalValue': {
      handler: function(newVal) {
        // 触发计算
        this.calculateDepreciation();
      },
      immediate: true // 立即执行一次监听函数
    },
    // 监听 预计折旧总月数 属性的变化
    'formData.expectUseMonth': {
      handler: function(newVal) {
        if (newVal === 0) {
          this.formData.currentMonthDepreciation = 0;
        }
        // 触发计算
        this.calculateDepreciation();
      },
      immediate: true // 立即执行一次监听函数
    },
    // 监听 已折旧月数 属性的变化
    'formData.useMonth': {
      handler: function(newVal) {
        // 触发计算
        this.calculateDepreciation();
      },
      // immediate: true // 立即执行一次监听函数
    },
    // 监听 资产数量 属性的变化
    'formData.number': {
      handler: function(newVal) {
        // 触发计算
        this.calculateOriginalValue();
      },
      immediate: true // 立即执行一次监听函数
    },
    // 监听 资产单价 属性的变化
    'formData.price': {
      handler: function(newVal) {
        // 触发计算
        this.calculateOriginalValue();
      },
      immediate: true // 立即执行一次监听函数
    },
    'formData.assetsTypeId': {
      handler: async function(newVal) {
        if (newVal && !this.editInput) {
          // 只有在新增模式下才自动生成编号
          const code = await this.generateNextAssetsCode();
          this.formData.assetsCode = code;
        }
      }
    },
  },
  methods: {
    /**
     * 加载所有需要的数据
     */
    async loadData() {
      try {
        // 并行加载所有需要的数据
        await Promise.all([
          this.loadAssetsType(),
          this.loadVoucherSelect(),
          this.loadDept()
        ]);
      } catch (error) {
        console.error('加载数据失败:', error);
        this.$Message.error('数据加载失败');
      }
    },

    /**
     * 加载资产类别数据
     */
    async loadAssetsType() {
      try {
        const response = await this.$api.assets.assetsType.list();
        this.assetsType = response.data || [];
      } catch (error) {
        console.error('获取资产类别列表失败:', error);
      }
    },

    /**
     * 加载凭证选择数据
     */
    async loadVoucherSelect() {
      try {
        const { data } = await this.$api.setting.subject.voucherSelect();
        this.voucherSelect = data;
      } catch (error) {
        console.error('获取凭证选择数据失败:', error);
      }
    },

    /**
     * 加载部门数据
     */
    async loadDept() {
      try {
        // 获取辅助核算类别列表
        const { data: categories } = await this.$api.setting.accountingCategory.list();
        const departmentItem = categories.find(val => val.name === '部门');

        if (departmentItem) {
          this.deptId = departmentItem.id;
          // 获取部门辅助核算详情列表
          const { data: deptData } = await this.$api.setting.accountingCategoryDetails.list(this.deptId, { page: 1, size: 9999 });
          this.dept = deptData.records || [];
        } else {
          console.warn('未找到"部门"数据');
          this.deptId = null;
          this.dept = [];
        }
      } catch (error) {
        console.error('获取部门数据失败:', error);
      }
    },

    async generateNextAssetsCode() {
      if (!this.formData.assetsTypeId) {
        return '';
      }
      try {
        // 根据资产类别ID获取该类别的资产列表，以确定下一个编号
        const assetsTypeItem = this.assetsType.find(type => type.id === this.formData.assetsTypeId);
        if (!assetsTypeItem) {
          return '';
        }

        // 获取该资产类别下的所有资产
        const response = await this.$api.assets.assets.list();
        const allAssets = response.data || [];

        // 筛选出相同资产类别的资产
        const sameTypeAssets = allAssets.filter(asset =>
            asset.assetsTypeId === this.formData.assetsTypeId && asset.id !== this.formData.id
        );

        // 获取该资产类别的编码前缀
        const typeCode = assetsTypeItem.categoryCode || '';

        if (!typeCode) {
          return '';
        }

        // 找出该类别下最大的序号
        let maxSequence = 0;
        sameTypeAssets.forEach(asset => {
          if (asset.assetsCode && asset.assetsCode.startsWith(typeCode)) {
            const sequenceStr = asset.assetsCode.substring(typeCode.length);
            const sequence = parseInt(sequenceStr, 10);
            if (!isNaN(sequence) && sequence > maxSequence) {
              maxSequence = sequence;
            }
          }
        });
        // 生成新的序号（三位数，不足补零）
        const nextSequence = maxSequence + 1;
        const sequenceStr = nextSequence.toString().padStart(3, '0');

        return typeCode + sequenceStr;
      } catch (error) {
        console.error('生成资产编号失败:', error);
        return '';
      }
    },

    /**
     * 资产数量改变时，计算资产原值
     */
    calculateOriginalValue() {
      const { price, number } = this.formData;
      this.formData.originalValue = price * number;
    },

    /**
     * 根据资产原值进行计算
     */
    calculateDepreciation() {
      const { originalValue, expectUseMonth, useMonth } = this.formData;
      const currentMonthDepreciation = originalValue / expectUseMonth;
      const remainingUseMonth = expectUseMonth - useMonth;

      if (remainingUseMonth < 0){
        this.formData.useMonth = expectUseMonth;
      }

      if (originalValue && expectUseMonth) {
        if (expectUseMonth > 0) {
          this.formData.currentMonthDepreciation = parseFloat(currentMonthDepreciation.toFixed(2));
          this.formData.totalDepreciation = originalValue - currentMonthDepreciation * useMonth;
          this.formData.remainingUseMonth = remainingUseMonth;
        } else {
          this.formData.currentMonthDepreciation = 0;
        }
      }
    },

    async submit() {
      let validResult = this.$refs.form.valid();
      if (validResult.result) {
        this.loading = true;
        this.formData.checkDate = moment(this.formData.checkDate).format("YYYY-MM-DD");

        try {
          await this.$api.assets.assets[this.formData.id ? 'update' : 'save'](this.formData);
          this.$Message.success('保存成功');
          this.visible = false;
          this.$emit('success', this.formData);
        } catch (error) {
          this.$Message.error('保存失败');
        } finally {
          this.loading = false;
        }
      }
    },

    onClose() {
      this.$emit('close');
    }
  }
};
</script>


